<template>
  <el-dialog
    v-drag
    title="分配银行账号"
    :visible.sync="dialogVisible"
    width="760px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <BaseTable
      class="data"
      :height="360"
      :tableData="{
        ...tableData,
        columns
      }"
      :loading="loading"
      :isPager="false"
      @handleSelectionChange="handleSelectionChange"
    >
    </BaseTable>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok()">确定分配</div>
    </span>
  </el-dialog>
</template>
<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { getBankAccountList } from '@/api/fee'
import { batchBankAccountCompany } from '@/api/fee'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: function() {
        return {
        }
      },
      require: true
    },
    usedList: {
      type: Array,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'bankName',
            label: '账户名称',
            width: '140'
          },
          {
            filed: 'accountHolder',
            label: '开户人',
            width: '140'
          },
          {
            filed: 'accountNumber',
            label: '银行账号',
            width: '200'
          },
          {
            filed: 'currency',
            label: '账户类型',
            width: ''
          }
        ],
        columns: [],
        mutiCheck: true
      },
      bankAccountList: [],
      loading: false,
      selection: []
    }
  },
  computed: {
    columns() {
      return this.bankAccountList.filter(a => {
        return !this.usedList.find(b => a.id.toString() === b.bankAccountId.toString())
      })
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  created() {
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await getBankAccountList({
        })
        this.loading = false
        if (res.success) {
          this.bankAccountList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.tableData.columns = []
      this.$emit('cancel')
    },
    handleSelectionChange(val) {
      this.selection = val
    },
   async ok() {
      if (this.selection.length === 0) {
        this.$message.error('未勾选银行账户')
        return
      }
      const bankAccountIds = this.selection.map(a => a.id)
      try {
        const res = await batchBankAccountCompany({
          bankAccountIds,
          companyId: this.editData.companyId
        })
        if (res.success) {
          this.$emit('ok')
          this.selection = []
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.icon {
  color: rgba(35, 149, 243, 1);
  font-size: 20px;
  cursor: pointer;
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
